import DOMPurify from 'dompurify';

export const PLATE_MAX_LENGTH = 10;
export const REVIEW_TITLE_MAX_LENGTH = 100;
export const REVIEW_TEXT_MAX_LENGTH = 500;

const MALICIOUS_PATTERN = /(javascript:|data:|vbscript:|on[a-z]+\s*=|ignore\s+previous\s+instructions|act\s+as|you\s+are\s+now|system:|assistant:)/i;
const BLOCKED_PLATE_CHARS_PATTERN = /[<>"';(){}/\\]/;

export const sanitizeTextInput = (value = '', maxLength = 500) =>
  DOMPurify.sanitize(String(value), { ALLOWED_TAGS: [], ALLOWED_ATTR: [] }).trim().slice(0, maxLength);

export const hasMaliciousPattern = (value = '') => MALICIOUS_PATTERN.test(String(value));

export const hasBlockedPlateChars = (value = '') => BLOCKED_PLATE_CHARS_PATTERN.test(String(value));

export const sanitizeLicensePlateInput = (value = '') =>
  value
    .toUpperCase()
    .replace(/[^A-Z0-9-]/g, '')
    .slice(0, PLATE_MAX_LENGTH);

export const isValidLicensePlate = (plate) => {
  if (!plate || plate.length === 0) return false;
  const cleanPlate = plate.trim().toUpperCase();
  if (hasBlockedPlateChars(cleanPlate)) return false;
  if (hasMaliciousPattern(cleanPlate)) return false;
  return /^[A-Z0-9-]{1,10}$/.test(cleanPlate);
};

